export * from './clientController.service';
import { ClientControllerService } from './clientController.service';
export * from './clientSubscriptionController.service';
import { ClientSubscriptionControllerService } from './clientSubscriptionController.service';
export * from './clientTagController.service';
import { ClientTagControllerService } from './clientTagController.service';
export * from './managementBulkClientProcessController.service';
import { ManagementBulkClientProcessControllerService } from './managementBulkClientProcessController.service';
export * from './managementClientController.service';
import { ManagementClientControllerService } from './managementClientController.service';
export * from './managementClientSubscriptionController.service';
import { ManagementClientSubscriptionControllerService } from './managementClientSubscriptionController.service';
export * from './managementClientTagController.service';
import { ManagementClientTagControllerService } from './managementClientTagController.service';
export * from './managementResellerController.service';
import { ManagementResellerControllerService } from './managementResellerController.service';
export const APIS = [ClientControllerService, ClientSubscriptionControllerService, ClientTagControllerService, ManagementBulkClientProcessControllerService, ManagementClientControllerService, ManagementClientSubscriptionControllerService, ManagementClientTagControllerService, ManagementResellerControllerService];
